export default __webpack_public_path__ + "static/media/bug.e5b5a1be.mp3";